import Backbone from 'backbone'
import template from './analyze-clusters.hbs'
import _ from 'lodash'
import formatValue from 'scoreboard/components/format-value'
import Chart from 'chart'

const AnalyzeClusters = Backbone.View.extend({

	className: 'analyze-clusters',

	initialize: function(options) {
		this.options = options
	},

	render: function() {
		let summaries = _.orderBy(this.options.summaries, ['score'], ['desc'])
			.map(({ numClusters, score }) => {
				return {
					numClusters,
					score: formatValue({ value: score, precision: 0 }),
					best: numClusters === this.options.bestNumClusters
				}
			})
		summaries = summaries.splice(0, 10) // Only show top 10 in the table
		this.$el.empty().append(template({ summaries }))
		this.renderChart()
		return this
	},
	/**
	 * #38218 display a bar graph of the clusters
	 */
	renderChart: function() {
		let rangeId = 1
		const range = []
		const points = []
		const largestScore = _.max(this.options.summaries.map(s => s.score))
		_.forEach(this.options.summaries, s => {
			// defines each bar
			range.push({
				id: rangeId,
				title: s.numClusters
			})
			// defines the data nd color of each bar
			points.push({
				color: s.score === largestScore ? 'blue-medium' : 'gray-medium',
				raw: s.score,
				rangeId: rangeId++,
				_topStack: true,
				_bottomStack: true,
				_range: [ 0, 1 ]
			})
		})

		const container = this.$('.chart-container')[0]
		const yMaxForce = Math.floor(_.maxBy(this.options.summaries, s => s.score).score)
		const formatter = (value) => formatValue({ value, precision: 0 })
		const chartData = {
			width: container.scrollWidth,
			height: 350,
			plots: [
				{
					id: 1,
					breakdown: { range },
					series: [
						{
							id: 1,
							points,
							type: 'bar',
							_columnIdx: 0,
							formatter
						}
					]
				}
			],
			axes: {
				left: { labels: true, yMaxForce, formatter },
				right: { labels: true },
				bottom: { labels: true }
			}
		}

		this.chart = new Chart(container)
		this.chart.render(chartData)
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invoke(this.chart, 'destroy')
	}

})

export default AnalyzeClusters

AnalyzeClusters.__filename__ = 'datasets/edit/fields/analyze-clusters.js'
